import { useEffect, useState } from "react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isInvestorRelations =
    typeof window !== "undefined" && window.location.pathname === "/investor-relations";
  const homePrefix = isInvestorRelations ? "/" : "";

  const navLinks = [
    { label: "Services", href: `${homePrefix}#services` },
    { label: "Approach", href: `${homePrefix}#approach` },
    { label: "Use Cases", href: `${homePrefix}#use-cases` },
    { label: "About", href: `${homePrefix}#about` },
    { label: "Investor Relations", href: "/investor-relations" },
    { label: "Contact", href: `${homePrefix}#contact` },
  ];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className={`site-header ${isScrolled ? "site-header--solid" : ""}`}>
      <div className="container header__inner">
        <a className="logo" href={`${homePrefix}#top`} onClick={handleNavClick}>
          <img src="/assets/gena_logo.png" alt="GenaImpact" />
          <span>GenaImpact</span>
        </a>
        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true" />
        </button>
        <nav className={`site-nav ${menuOpen ? "is-open" : ""}`}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={handleNavClick}>
              {link.label}
            </a>
          ))}
          <a
            className="btn btnPrimary nav-cta"
            href={`${homePrefix}#contact`}
            onClick={handleNavClick}
          >
            Book a Discovery Call
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
